module.exports = __webpack_public_path__ + "static/img/089_TO8_1751.2e56c62.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/089_TO8_1751.jpg
// module id = fyyI
// module chunks = 0